import React from 'react'
import ReactPaginate from 'react-paginate';

function Paginator({ pageCount, handlePageClick, forcePage = 0 }) {
  return <ReactPaginate
    breakLabel={"..."}
    nextLabel={"Next"}
    forcePage={forcePage}
    onPageChange={handlePageClick}
    pageCount={pageCount}
    previousLabel={'Prev'}
    renderOnZeroPageCount={null}
    marginPagesDisplayed={2}
    pageRangeDisplayed={3}
    containerClassName={'pagination justify-content-end'}
    pageClassName={"page-item"}
    pageLinkClassName={'page-link'}
    previousClassName={'page-item'}
    previousLinkClassName={'page-link'}
    nextClassName={'page-item'}
    nextLinkClassName={'page-link'}
    breakClassName={'page-item'}
    breakLinkClassName={'page-link'}
    activeClassName={'active'}
  />
}

export default Paginator;